import { ContractModel } from "src/app/global/contract-filter-model";
import { eroiIds } from "../../total-value-delivery/types/tvd-types";
import { ActionData, ActionState, ActionStatus, TvdEroiDto } from "./action-center-types";

export const filters: ContractModel = { 
    division: "Institutional",
    dataView: "Contract",
    regions: ["NA"]   ,
    countries: ["USA"],
    period: "R12",
    presentationType: "All",
    translation: "English",
    topLevelContractGroup: ["12345678"],
    secondLevelContractFilter: [],
    thirdLevelContractFilter: [],
    fourthLevelContractFilter: [],
    accts: [],
    dateRange: undefined
  };

export const OpportunityTypes = [
    'sales',
    // tvd metrics
    eroiIds.PRODUCTIVITY,
    eroiIds.ASSETS,
    eroiIds.WATER,
    eroiIds.ENERGY,
    eroiIds.GREENHOUSEGASES,
    eroiIds.PLASTIC,
    eroiIds.CARDBOARD,
    eroiIds.EMPLOYEESAFETY,
    eroiIds.COSTAVOIDANCE
]

export const emptyTvdEroiDto: TvdEroiDto = {
    totalAir: 0,
    totalRepair: 0,
    totalProductivity: 0,
    totalProductivityDollars: 0,
    totalReplacement: 0,
    totalEnergy: 0,
    totalEnergyDollars: 0,
    totalPlasticWaste: 0,
    totalPlasticWasteDollars: 0,
    totalWater: 0,
    totalWaterDollars: 0,
    totalValueDeliveredDollars: 0,
    totalCardboardWaste: 0,
    totalCardboardWasteDollars: 0,
    totalEmployeeSafety: 0,
    totalPortfolioReduction: 0,
    totalPortfolioReductionDollars: 0,
    totalCostAvoidance: 0,
    totalSales: 0
}

export const completedpagedata: ActionData[] = [
    {
        recId: "3",
        sku: "SKU12345",
        productName: "Product C",
        solution: "Solution C",
        groupedTVDOpportunity: {
            totalAir: 100,
            totalRepair: 200,
            totalProductivity: 300,
            totalProductivityDollars: 400,
            totalReplacement: 500,
            totalEnergy: 600,
            totalEnergyDollars: 700,
            totalPlasticWaste: 800,
            totalPlasticWasteDollars: 900,
            totalWater: 1000,
            totalWaterDollars: 1100,
            totalValueDeliveredDollars: 1200,
            totalCardboardWaste: 1300,
            totalCardboardWasteDollars: 1400,
            totalEmployeeSafety: 1500,
            totalPortfolioReduction: 1600,
            totalPortfolioReductionDollars: 1700,
            totalCostAvoidance: 1800,
            totalSales: 1900
        },
        groupedSalesOpportunity: 10000,
        currentLocations: [
            {
                key: "12345678_6100046",
                accountNumber: "ACC123",
                accountName: "Account A",
                street: "123 Main St",
                city: "City A",
                state: "State A",
                zip: "12345",
                country: "Country A",
                reasonSolution: "Reason Solution A",
                reasonProducts: "Reason Products A"
            }
        ],
        groupedDifficultyScale: 5,
        previousLocations: [],

        actionNotes: [
            {
                noteDate: (new Date()).toUTCString(),
                noteContents: "Note A"
            }
        ],
        recState: {
            recommendationState: ActionState.Completed,
            recommendationStatus: ActionStatus.CustomerAccepted,
            snoozeDate: (new Date()).toUTCString(),
            snoozeDuration: 0,
            startDate: (new Date(Date.now())).toUTCString(),
            endDate: (new Date(Date.now())).toUTCString(),
            dismissReason: ""
        }
    }
];

export const dismissedpagedata: ActionData[] = [
    {
        recId: "4",
        sku: "SKU12345",
        productName: "Product D",
        solution: "Solution D",
        groupedTVDOpportunity: {
            totalAir: 100,
            totalRepair: 200,
            totalProductivity: 300,
            totalProductivityDollars: 400,
            totalReplacement: 500,
            totalEnergy: 600,
            totalEnergyDollars: 700,
            totalPlasticWaste: 800,
            totalPlasticWasteDollars: 900,
            totalWater: 1000,
            totalWaterDollars: 1100,
            totalValueDeliveredDollars: 1200,
            totalCardboardWaste: 1300,
            totalCardboardWasteDollars: 1400,
            totalEmployeeSafety: 1500,
            totalPortfolioReduction: 1600,
            totalPortfolioReductionDollars: 1700,
            totalCostAvoidance: 1800,
            totalSales: 1900
        },
        groupedSalesOpportunity: 10000,
        currentLocations: [
            {
                key: "12345678_6100046",
                accountNumber: "ACC123",
                accountName: "Account A",
                street: "123 Main St",
                city: "City A",
                state: "State A",
                zip: "12345",
                country: "Country A",
                reasonSolution: "Reason Solution A",
                reasonProducts: "Reason Products A"
            }
        ],
        groupedDifficultyScale: 5,
        previousLocations: [],

        actionNotes: [
            {
                noteDate: (new Date()).toUTCString(),
                noteContents: "Note A"
            }
        ],
        recState: {
            recommendationState: ActionState.Completed,
            recommendationStatus: ActionStatus.CustomerAccepted,
            snoozeDate: (new Date()).toUTCString(),
            snoozeDuration: 0,
            startDate: (new Date(Date.now())).toUTCString(),
            endDate: (new Date(Date.now())).toUTCString(),
            dismissReason: ""
        }
    }
];

export const myactionspagedata: ActionData[] = [
    {
        recId: "1",
        sku: "SKU12345",
        productName: "Product A",
        solution: "Solution A",
        groupedTVDOpportunity: {
            totalAir: 100,
            totalRepair: 200,
            totalProductivity: 300,
            totalProductivityDollars: 400,
            totalReplacement: 500,
            totalEnergy: 600,
            totalEnergyDollars: 700,
            totalPlasticWaste: 800,
            totalPlasticWasteDollars: 900,
            totalWater: 1000,
            totalWaterDollars: 1100,
            totalValueDeliveredDollars: 1200,
            totalCardboardWaste: 1300,
            totalCardboardWasteDollars: 1400,
            totalEmployeeSafety: 1500,
            totalPortfolioReduction: 1600,
            totalPortfolioReductionDollars: 1700,
            totalCostAvoidance: 1800,
            totalSales: 1900
        },
        groupedSalesOpportunity: 10000,
        
        currentLocations: [
            {
                key: "12345678_6100046",
                accountNumber: "ACC123",
                accountName: "Account A",
                street: "123 Main St",
                city: "City A",
                state: "State A",
                zip: "12345",
                country: "Country A",
                reasonSolution: "Reason Solution A",
                reasonProducts: "Reason Products A"
            }
        ],
        groupedDifficultyScale: 5,
        actionNotes: [
            {
                noteDate: (new Date()).toUTCString(),
                noteContents: "Note A"
            }
        ],
        previousLocations: [],

        recState: {
            recommendationState: ActionState.MyActions,
            recommendationStatus: ActionStatus.CustomerAccepted,
            snoozeDate: (new Date()).toUTCString(),
            snoozeDuration: 0,
            startDate: (new Date()).toUTCString(),
            endDate: (new Date()).toUTCString(),
            dismissReason: "Dismiss Reason A"
        }
    },
    {
        recId: "2",
        sku: "SKU67890",
        productName: "Product B",
        solution: "Solution B",
        groupedTVDOpportunity: {
            totalAir: 110,
            totalRepair: 210,
            totalProductivity: 310,
            totalProductivityDollars: 410,
            totalReplacement: 510,
            totalEnergy: 610,
            totalEnergyDollars: 710,
            totalPlasticWaste: 810,
            totalPlasticWasteDollars: 910,
            totalWater: 1010,
            totalWaterDollars: 1110,
            totalValueDeliveredDollars: 1210,
            totalCardboardWaste: 1310,
            totalCardboardWasteDollars: 1410,
            totalEmployeeSafety: 1510,
            totalPortfolioReduction: 1610,
            totalPortfolioReductionDollars: 1710,
            totalCostAvoidance: 1810,
            totalSales: 1910
        },
        groupedSalesOpportunity: 20000,
        previousLocations: [],
        currentLocations: [
            {
                key: "12345678_6100046",
                accountNumber: "ACC456",
                accountName: "Account B",
                street: "456 Elm St",
                city: "City B",
                state: "State B",
                zip: "67890",
                country: "Country B",
                reasonSolution: "Reason Solution B",
                reasonProducts: "Reason Products B"
            }
        ],
        groupedDifficultyScale: 7,
        actionNotes: [
            {
                noteDate: (new Date()).toUTCString(),
                noteContents: "Note B"
            }
        ],
        recState: {
            recommendationState: ActionState.MyActions,
            recommendationStatus: ActionStatus.NoActionYet,
            snoozeDate: (new Date()).toUTCString(),
            snoozeDuration: 0,
            startDate: (new Date()).toUTCString(),
            endDate: (new Date()).toUTCString(),
            dismissReason: "Dismiss Reason B"
        }
    }
];

export const snoozedpagedata: ActionData[] = [{
    recId: "5",
    sku: "SKU12345",
    productName: "Product E",
    solution: "Solution E",
    groupedTVDOpportunity: {
        totalAir: 100,
        totalRepair: 200,
        totalProductivity: 300,
        totalProductivityDollars: 400,
        totalReplacement: 500,
        totalEnergy: 600,
        totalEnergyDollars: 700,
        totalPlasticWaste: 800,
        totalPlasticWasteDollars: 900,
        totalWater: 1000,
        totalWaterDollars: 1100,
        totalValueDeliveredDollars: 1200,
        totalCardboardWaste: 1300,
        totalCardboardWasteDollars: 1400,
        totalEmployeeSafety: 1500,
        totalPortfolioReduction: 1600,
        totalPortfolioReductionDollars: 1700,
        totalCostAvoidance: 1800,
        totalSales: 1900
    },
    groupedSalesOpportunity: 10000,
    previousLocations: [],
    currentLocations: [
        {
            key: "12345678_6100046",
            accountNumber: "ACC123",
            accountName: "Account A",
            street: "123 Main St",
            city: "City A",
            state: "State A",
            zip: "12345",
            country: "Country A",
            reasonSolution: "Reason Solution A",
            reasonProducts: "Reason Products A"
        }
    ],
    groupedDifficultyScale: 5,
    actionNotes: [
        {
            noteDate: (new Date()).toUTCString(),
            noteContents: "Note A"
        }
    ],
    recState: {
        recommendationState: ActionState.Snoozed,
        recommendationStatus: ActionStatus.CustomerAccepted,
        snoozeDate: (new Date(Date.now())).toUTCString(),
        snoozeDuration: 3,
        startDate: (new Date()).toUTCString(),
        endDate: (new Date()).toUTCString(),
        dismissReason: "Dismiss Reason A"
    }
}];

export const tvdMapping: { [key: string]: string } = {
    "Assets": "totalRepairAndReplacement", // Not used, combined value calculated in method.
    "Cardboard Waste": "totalCardboardWasteDollars",
    "Cost Avoidance": "totalCostAvoidance",
    "Energy": "totalEnergyDollars",
    "Greenhouse Gases": "totalAir", 
    "Plastic Waste": "totalPlasticWasteDollars",
    "Productivity": "totalProductivityDollars",
    "Water": "totalWaterDollars",
    "Employee Safety": "totalEmployeeSafety"
};